<template>
    <div v-if="isValid('CanViewItem')">

        <div class="row">
            <div class="col-lg-12 col-sm-12 ml-auto mr-auto">
                <div class="row mb-4" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <h5 class="page_title">{{ $t('Product.ListOfITems') }}</h5>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link :to="'/StartScreen'"><a href="javascript:void(0)"> {{ $t('Product.Home') }}</a></router-link></li>

                                <li class="breadcrumb-item active" aria-current="page"> {{ $t('Product.InventoryItems') }}</li>
                            </ol>
                        </nav>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-6">
                        <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a href="javascript:void(0)" class="btn btn-outline-primary " v-if="isValid('CanAddItem')" v-on:click="AddProduct"><i class="fa fa-plus"></i> {{ $t('Product.AddNew') }}</a>
                            <router-link :to="'/StartScreen'"><a href="javascript:void(0)" class="btn btn-outline-danger "> {{ $t('Product.Close') }}</a></router-link>
                        </div>
                    </div>
                </div>
                <div class="card ">
                    <div class="card-header">

                        <div class="row mb-3 " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                                <div class="form-group">
                                    <label>{{ $t('Product.SearchbyProductName') }}</label>
                                    <div>
                                        <input type="text" class="form-control search_input" v-model="search" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" name="search" id="search" :placeholder="$t('Product.SearchbyProductName')" />
                                        <span class="fas fa-search search_icon"></span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-1 col-lg-1 mt-3 " v-if="isValid('CanFilterItem')">
                                <div class="form-group">
                                    <div class="form-group ml-3">
                                        <a href="javascript:void(0)" v-on:click="FilterWareHouse" class="btn btn-outline-primary "><i class="fa fa-filter"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>{{ $t('Product.SearchbyWareHosue') }}</label>
                                <warehouse-dropdown v-model="warehouseId" v-on:selected="getPage()" v-on:input="getPage()" />
                            </div>
                            <div class="col-md-1 col-lg-1  " style="margin-top:14px" v-if="advanceFilters">
                                <a href="javascript:void(0)" id="hide" v-on:click="OpenProductModel" class="btn btn-outline-primary  float-right">{{ $t('Product.Item') }}</a>
                            </div>
                            <div class="col-md-3 col-lg-3 mt-3 text-right " v-if=" isValid('CanImportProduct')">
                                <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="ImportDataFromCsv">{{$t('Product.ImportItems')}}</a>
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters && isValid('CanViewProduct')">
                                <label>{{ $t('Product.SearchbyProduct') }}</label>
                                <productMasterdropdown v-model="produtMaster" :isMultiple="true" v-on:input="GetFilter('productMaster')"></productMasterdropdown>
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>{{ $t('Product.SearchbyCategory') }}</label>
                                <categorydropdown v-model="category" :isMultiple="true" v-on:input="GetFilter('Category')"></categorydropdown>
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>Search by Sub Category</label>
                                <multiselect v-model="subCategory" v-on:input="GetFilter('SubCategory')" :multiple="true" :options="subCategoryOptions"  :show-labels="false" track-by="name" label="name" v-bind:class="$i18n.locale == 'en' ? 'text-left ' : 'arabicLanguage '" v-bind:placeholder="$t('AddProduct.PleaseSelectSubCategory')">
                                </multiselect>
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>{{ $t('Product.SearchbyColor') }}</label>
                                <colordropdown v-model="color" :isMultiple="true" v-on:input="GetFilter('Color')" />
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>{{ $t('Product.SearchbySize') }}</label>
                                <sizedropdown v-model="size" :isMultiple="true" v-on:input="GetFilter('Size')" />
                            </div>
                            <div class="col-md-3 col-lg-3  col-12 " id="hide" v-if="advanceFilters">
                                <label>{{ $t('Product.SearchbyOrigin') }}</label>
                                <origindropdown v-model="origin" :isMultiple="true" v-on:input="GetFilter('Origin')" />
                            </div>
                            <div class="col-md-1 col-lg-1  col-3 pt-3" v-if="advanceFilters">
                                <button class="btn btn-light btn-block text-left" v-on:click="GetFilterPdfRecord(true)">PDF <i class="fas fa-file-pdf float-right" style="color:#EB5757;"></i></button>
                            </div>
                            <!--<div class="col-md-1 col-lg-1  col-3  col-2 pt-3" v-if="advanceFilters">
                                <button class="btn btn-light btn-block text-left">Sheets <i class="fas fa-file-excel float-right" style="color:#198754;"></i></button>
                            </div>-->



                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <loading :active.sync="loading" :can-cancel="true" :is-full-page="false"></loading>

                            <div class="col-lg-12">

                                <div class="mt-2">
                                    <div class=" table-responsive ">
                                        <table class="table table-hover table-striped table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                            <thead class="m-0">
                                                <tr>
                                                    <th style="width:10%;text-align:center;">
                                                        {{ $t('Product.Image') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Product.Code') }}
                                                    </th>
                                                    <th v-if="english=='true'">
                                                        {{ $t('Product.ItemName') |englishLanguage}}
                                                    </th>

                                                    <th v-if="isOtherLang()">
                                                        {{ $t('Product.ItemName') |arabicLanguage}}
                                                    </th>
                                                    <th class="text-center" width="30%">
                                                        {{ $t('Product.Description') }}
                                                    </th>
                                                    <th class="text-center">
                                                        {{ $t('Product.SalePrice') }}
                                                    </th>

                                                    <th class="text-center" v-if="isValid('CanViewCurrentStock')">

                                                        {{ $t('Product.CurrentStock') }}
                                                    </th>
                                                    <!--<th class="text-center">
                                {{ $t('Product.CurrentStockValue') }}
                            </th>-->
                                                    

                                                    <th class="text-center" v-if="isValid('CanViewDetailItem')">

                                                        {{ $t('Product.ViewDetail') }}


                                                    </th>





                                                    <!--<th>
                                {{ $t('Product.LENGTH') }}
                            </th>
                            <th>
                                {{ $t('Product.SALE_RETURN_DAYS') }}
                            </th>-->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="details in productList" v-bind:key="details.id">

                                                    <td v-if="details.image==null || details.image=='' || details.image==undefined" class="text-center"><img src="productList.svg" style="width: 50px;" /></td>
                                                    <td v-else class="text-center"><productimage v-bind:path="details.image" /></td>
                                                    <td v-if="isValid('CanEditItem')">
                                                        <strong v-if="details.isRaw">
                                                            <a href="javascript:void(0)" style="color:red" v-on:click="EditProductInfo(details.id)">{{details.code}}</a>
                                                        </strong>
                                                        <strong v-else>
                                                            <a href="javascript:void(0)" v-on:click="EditProductInfo(details.id)">{{details.code}}</a>
                                                        </strong>
                                                    </td>
                                                    <td v-else v-bind:style="details.isRaw == true ? 'color:!important red' : ''"> {{details.code}}</td>

                                                    <td v-if="english=='true' && isOtherLang()">
                                                        <span v-if="details.isRaw">
                                                            {{details.englishName}}
                                                            <label style="color:red">{{ $t('Product.RawMaterial') }}</label>
                                                        </span>
                                                        <span v-else>
                                                            {{details.englishName}}
                                                        </span>
                                                    </td>

                                                    <td v-else-if="english=='true'">
                                                        <span v-if="details.isRaw">
                                                            <span v-if="details.englishName != ''">{{details.englishName}}</span>
                                                            <span v-else>{{details.arabicName}}</span>
                                                            <label style="color:red">{{ $t('Product.RawMaterial') }}</label>
                                                        </span>
                                                        <span v-else>
                                                            <span v-if="details.englishName != ''">{{details.englishName}}</span>
                                                            <span v-else>{{details.arabicName}}</span>
                                                        </span>
                                                    </td>
                                                    <td v-if="english=='true' && isOtherLang()">
                                                        <span v-if="details.isRaw">
                                                            {{details.arabicName}}
                                                            <label style="color:red">{{ $t('Product.RawMaterial') }}</label>
                                                        </span>
                                                        <span v-else>
                                                            {{details.arabicName}}
                                                        </span>
                                                    </td>
                                                    <td v-else-if="isOtherLang()">
                                                        <span v-if="details.isRaw">
                                                            <span v-if="details.arabicName != ''">{{details.arabicName}}</span>
                                                            <span v-if="details.arabicName != ''">{{details.arabicName}}</span>
                                                            <span v-else>{{details.englishName}}</span>
                                                            <label style="color:red">{{ $t('Product.RawMaterial') }}</label>
                                                        </span>
                                                        <span v-else>
                                                            <span v-if="details.arabicName != ''">{{details.arabicName}}</span>
                                                            <span v-else>{{details.englishName}}</span>
                                                        </span>
                                                    </td>

                                                    <td class="text-center">{{details.description}}</td>
                                                    <td class="text-center">{{details.salePrice}}</td>
                                                    <!--<td class="text-center">{{details.purchasePrice==null? 0: (details.purchasePrice.price)}}</td>-->
                                                 

                                                    <td class="text-center" v-if="isValid('CanViewCurrentStock')">

                                                        {{details.inventory==null? 0: details.inventory.currentQuantity}} <br />
                                                        <div class="badge badge-danger" v-if="details.stockLevel< (details.inventory==null? 0: details.inventory.currentQuantity)? '' : 'higlight'">{{ $t('Product.LowStock') }}</div>
                                                    </td>
                                                    <!--<td class="text-center">{{details.inventory==null? 0: details.inventory.currentStockValue}}</td>-->
                                                  

                                                    <td class="text-center" v-if="isValid('CanViewDetailItem')">
                                                        <button value="View" class="btn btn-icon btn-sm  btn-primary mr-1" v-on:click="ViewProductInfo(details.id)"><i class="fas fa-eye"></i></button>


                                                        <!--<a href="javascript:void(0)" title="A4" class="btn  btn-icon btn-primary btn-sm" v-on:click="PrintProductInfo(details.id)"><i class=" fa fa-print"></i></a>-->
                                                    </td>

                                                    <!--<td>{{details.length}}</td>
                            <td>{{details.saleReturnDays}}</td>-->
                                                </tr>


                                              


                                            </tbody>


                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>



                        <div class="float-left">
                            <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                            <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                            <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                            <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                            <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                        </div>
                        <div class="float-right">
                            <div class="overflow-auto" v-on:click="GetProductData()" v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                <b-pagination pills size="lg" v-model="currentPage"
                                              :total-rows="rowCount"
                                              :per-page="10"
                                              first-text="First"
                                              prev-text="Previous"
                                              next-text="Next"
                                              last-text="Last"></b-pagination>
                            </div>
                            <div class="overflow-auto" v-on:click="GetProductData()" v-else>
                                <b-pagination pills size="lg" v-model="currentPage"
                                              :total-rows="rowCount"
                                              :per-page="10"
                                              first-text="الأولى"
                                              prev-text="السابقة"
                                              next-text="التالية"
                                              last-text="الأخيرة"></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <productfiltermodel :show="show"
                                    v-if="show"
                                    @close="show=false" />
            </div>
        </div>
        <ProductFilterDownloadReport :headerFooter="headerFooter" :printDetails="filterProduct" v-if="isDownload" v-bind:key="printRenderPdf"></ProductFilterDownloadReport>
        <productPrintReport v-if="showPrint" :printDetails="productData" :headerFooter="headerFooter" v-bind:key="printRender"></productPrintReport>

    </div>
    <div v-else>  <acessdenied></acessdenied></div>
</template>
<style scoped>
    .higlight {
        background-color: red;
    }
</style>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import Multiselect from 'vue-multiselect'
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        mixins: [clickMixin],
        components: {
            Multiselect,
            Loading

        },
        name: 'product',
        data: function () {
            return {
                arabic: '',
               
                produtMaster: '',
                size: '',
                origin: '',
                english: '',
                category: '',
                subCategory: '',
                productMasterId: '',
                categoryId: '',
                subCategoryId: '',
                sizeId: '',
                color: '',
                colorId: '',
                originId: '',
                wareHouseId: '',
                show: false,
                download: false,
                isDownload: false,
                type: '',
                showPrint: false,
                productData: '',
                productFilter: {
                    productMasterId: '',
                    categoryId: '',
                    subCategoryId: '',
                    sizeId: '',
                    colorId: '',
                    originId: '',
                    wareHouseId: '',
                    searchTerm: '',
                    pageNumber: 1,
                    isDropdown:false,



                },
                filterProduct: [],
                subCategoryOptions: [],
                productList: [

                ],
                warehouseId: '',

                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                searchQuery: '',
                image: '',
                loading: true,
                renderedImage: 0,
                printRenderPdf: 0,
                advanceFilters: false,
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                printRender: 0
            }
        },
        watch: {
            search: function (val) {
                this.GetProductData(val, 1);
            },

        },
        methods: {
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }
                    });
            },
            OpenProductModel: function () {
                this.show = !this.show;
            },
            getSubcategory: function () {
                //this.catId = event;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }


                this.subCategoryOptions = [];
                this.$https.get('/Product/GetSubCategoryInformation?isActive=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        response.data.results.subCategories.forEach(function (rout) {
                           
                            root.subCategoryOptions.push({
                                id: rout.id,
                                name: root.$i18n.locale == 'en' ? (rout.name != "" ? rout.code + ' ' + rout.name : rout.code + ' ' + rout.nameArabic) : (rout.nameArabic != '' ? rout.code + ' ' + rout.nameArabic : rout.code + ' ' + rout.name)
                            })
                        })
                    }
                })
            },
            GetFilter: function (filterName) {
                debugger;
                if (filterName == 'productMaster') {
                    if (this.produtMaster == null || this.produtMaster == undefined) {
                        this.productMasterId = '';
                    }
                    else {
                        this.productMasterId = this.getOriginId(this.produtMaster);

                    }
                }
                else if (filterName == 'Category') {

                    if (this.categoryId == null || this.categoryId == undefined) {
                        this.categoryId = '';
                    }
                    else {
                        this.categoryId = this.getOriginId(this.category);

                    }
                    //else {
                    //    this.getSubcategory(this.categoryId)
                    //}


                    
                }
                else if (filterName == 'Color') {

                    if (this.colorId == null || this.colorId == undefined) {
                        this.colorId = '';
                    }
                    else {
                        this.colorId = this.getOriginId(this.color);

                    }


                    
                }
                else if (filterName == 'Size') {

                    if (this.sizeId == null || this.sizeId == undefined) {
                        this.sizeId = '';
                    }
                    else {
                        this.sizeId = this.getOriginId(this.size);

                    }


                    
                }
                else if (filterName == 'SubCategory') {

                    if (this.subCategoryId == null || this.subCategoryId == undefined) {
                        this.subCategoryId = '';
                    }
                    else {
                        this.subCategoryId = this.getOriginId(this.subCategory);
                    }


                    
                }
                else if (filterName == 'Origin') {
                    debugger;

                    if (this.originId == null || this.originId == undefined) {
                        this.originId = '';
                    }
                    else {
                        this.originId = this.getOriginId(this.origin);

                    }


                    
                }


                this.GetProductData();

            },
            getOriginId: function (value) {
                var originId = [];
                for (var i = 0; i < value.length; i++) {
                    originId[i] = value[i].id
                }
                return originId;
            },
            FilterWareHouse: function () {

                this.advanceFilters = !this.advanceFilters;
                if (this.advanceFilters == false) {
                    this.warehouseId = '';
                    this.productMasterId = '';
                    this.categoryId = '';
                    this.colorId = '';
                    this.sizeId = '';
                    this.subCategoryId = '';
                    this.originId = '';
                    this.currentPage = 1;
                    this.GetProductData(this.search, 1, this.warehouseId);
                    this.getSubcategory();
                }
                

            },
            ImportDataFromCsv: function () {
                var root = this;
                root.$router.push({
                    path: '/ImportExportRecords',
                    query: {data:'Item'}
                })
            },

            getPage: function () {


                this.GetProductData(this.search, this.currentPage, this.warehouseId);
            },
            GetFilterPdfRecord: function (download) {
                debugger;
              
                var root = this;
                if (download) {
                    this.GetHeaderDetail();
                   

                }
                this.filterProduct = [];
                this.loading = true;
                this.productFilter.searchTerm = this.search;
                this.productFilter.pageNumber = this.currentPage;
                this.productFilter.warehouseId = this.warehouseId;
                this.productFilter.productMasterId = this.productMasterId;
                this.productFilter.categoryId = this.categoryId;
                this.productFilter.subCategoryId = this.subCategoryId;
                this.productFilter.colorId = this.colorId;
                this.productFilter.sizeId = this.sizeId;
                this.productFilter.originId = this.originId;
                this.productFilter.isDropdown = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var url = '/Product/GetProductFilterInformation';

                root.$https.post(url, this.productFilter, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        debugger;
                        console.log(response.data.results.products);
                        root.filterProduct = response.data.results.products;
                        root.isDownload = true;
                        root.loading = false;

                        root.printRenderPdf++;
                        
                    }
                });
            },
            GetProductData: function () {
                debugger;
                if (localStorage.getItem("BarcodeScan") != 'Product')
                    return
                var root = this;

                this.productFilter.searchTerm = this.search;
                this.productFilter.pageNumber = this.currentPage;
                this.productFilter.warehouseId = this.warehouseId;
                this.productFilter.productMasterId = this.productMasterId;
                this.productFilter.categoryId = this.categoryId;
                this.productFilter.subCategoryId = this.subCategoryId;
                this.productFilter.colorId = this.colorId;
                this.productFilter.sizeId = this.sizeId;
                this.productFilter.originId = this.originId;
                this.productFilter.isDropdown = false;
                this.loading = true;


                var url = '/Product/GetProductFilterInformation' ;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.post(url, this.productFilter, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        console.log(response.data.results.products);
                        root.productList = response.data.results.products;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });
            },
            AddProduct: function () {
                var root = this;
                root.$router.push({
                    path: '/addproduct',
                    query: {
                        prop: Math.ceil(root.rowCount / 10)
                    }
                })
            },
            EditProductInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/ProductDetailsViaId?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        root.$router.push({
                            path: '/addproduct',
                            query: {
                                data: response.data,
                                prop: root.currentPage
                            }
                        })
                    }
                });
            },
            PrintProductInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/ProductViewDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        root.productData = response.data;
                        root.showPrint = true;
                        root.printRender++

                    }
                });
            },
            ViewProductInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/ProductViewDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        root.$router.push({
                            path: '/ProductView',
                            query: {
                                data: response.data,
                                prop: root.currentPage,

                            }
                        })
                    }
                });
            },
        },

        created: function () {
            var root = this;
            //For Scanner Code
            var barcode = '';
            var interval;
            document.addEventListener('keydown', function (evt) {
                if (interval)
                    clearInterval(interval);
                if (evt.code === 'Enter') {
                    if (barcode) {
                        root.search = barcode
                        root.GetProductData();
                    }
                    barcode = '';
                    return;

                }
                if (evt.key !== 'Shift')
                    barcode += evt.key;
            });

            //End

            this.$emit('input', this.$route.name);
            localStorage.setItem("BarcodeScan", 'Product')
        },
        mounted: function () {
            this.GetHeaderDetail();
            this.showPrint = false;
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            if (this.$route.query.data != undefined) {
                this.currentPage = this.$route.query.data;
                this.GetProductData();
            }
            else {
                this.GetProductData(this.search, 1);
            }
        }
    }
</script>